import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import articles from '../data/articles.json';
import RightSideBar from '../view/RightSideBar';
import Env from '../model/Env';
import Meta from '../model/Meta';

class BlogPost extends Component {

    componentDidMount(){
        $('html, body').animate({scrollTop: 0}, 300);
    }

    render() {
        
        // Get specific article
        let post = articles.articles.filter((article) => {
		    return article.title.replace(/[\W_]/g, " ").replace(/\s+/g, '-').toLowerCase() === this.props.match.params.title;
        });
        
        // Article not found redirect to blog main
        if(post.length===0) {
            window.location.href="/blog";
        }

        const meta = {
			title: post[0].title,
			description: `${post[0].title} by ${post[0].author}`
		}

        return(
            <div className="page page-inner not-found pb-5 blog-post">
                <Meta {...meta}/>
                <div className="container-fluid">
                    <div className="container p-0">
                        <div className="row">
                            <div className="col-sm-12 col-md-7">
                                <h1 className="page-title">{post[0].title}</h1>
                                <p className="post-author"><small>{post[0].author}</small></p>
                                <div className="page-content">
                                    <div className="text-center">
                                        <img src={post[0].image} alt={post[0].title} className="img-fluid" />
                                    </div>
                                    <div className="mt-3" dangerouslySetInnerHTML={{__html: post[0].content}}></div>
                                </div>
                                <div className="text-center my-3">
                                    <Link to="/blog" className="btn btn-lightblue w-100">Back to main Blog</Link>
                                </div>
                                <div className="fb-comments" data-href={`${Env.BASE_URL}${this.props.location.pathname}`} data-width="100%" data-numposts="5"></div>
                            </div>
                            <div className="col-sm-12 col-md-5">
                                <RightSideBar />
                            </div>
                        </div>
                    </div>
                </div>
                
                
            </div>
        )
    }
    
}

export default BlogPost;


// WEBPACK FOOTER //
// ./src/pages/BlogPost.js